export default __webpack_public_path__ + "static/media/logo-bolsa.eb03a1e8.png";